import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
var INITIAL_STATE = {
  title: "",
  variant: "info",
  platformResponse: null
};
export var useNotifications = function useNotifications() {
  var _React$useState = React.useState(INITIAL_STATE),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      notification = _React$useState2[0],
      setNotification = _React$useState2[1];

  var addSuccessNotification = function addSuccessNotification(title) {
    setNotification({
      title: title,
      variant: "success"
    });
  };

  var addFailureNotification = function addFailureNotification(title) {
    setNotification({
      title: title,
      variant: "error"
    });
  };

  var addInfoNotification = function addInfoNotification(title, duration) {
    setNotification({
      title: title,
      variant: "info",
      duration: duration
    });
  };

  var clearNotification = function clearNotification() {
    setNotification(_objectSpread({}, INITIAL_STATE, {
      variant: notification.variant
    }));
  };

  return {
    notification: notification,
    addSuccessNotification: addSuccessNotification,
    addFailureNotification: addFailureNotification,
    addInfoNotification: addInfoNotification,
    clearNotification: clearNotification
  };
};